import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faCouch,
    faLayerGroup,
    faGridHorizontal,
    faDesktop,
    faBuilding,
    faHouseLaptop,
    faClock,
    faCalendarDays,
    faUsers,
} from "@fortawesome/pro-solid-svg-icons"

const useStyles = makeStyles()((theme) => ({
    icon: {
        fontSize: "1rem",
    },
    iconGrey: {
        color: theme.palette.tailwind.slate[400],
    },
    iconLight: {
        color: theme.palette.common.white,
    },
}))

type FilterIconProps = {
    filterType: string
    isLight?: boolean
}

export function FilterIcon({ filterType, isLight = false }: FilterIconProps) {
    const { classes, cx } = useStyles()

    const filterIcons = {
        serviceCenterIds: faBuilding,
        floors: faLayerGroup,
        sittings: faCouch,
        tableSetupIds: faGridHorizontal,
        fixedAvIds: faDesktop,
        resourceTypeIds: faHouseLaptop,
        meetingDuration: faClock,
        startDateTime: faCalendarDays,
        meetingType: faUsers,
    }

    return (
        <FontAwesomeIcon
            icon={filterIcons[filterType as keyof typeof filterIcons]}
            className={cx(classes.icon, isLight ? classes.iconLight : classes.iconGrey)}
        />
    )
}
